import { createContext, useContext } from 'react';
import type { ApiErrors } from './types';
import type { FieldRegistration } from './apiValidation';

export type RegisteredControl = FieldRegistration & {
  id: string;
  control: () => HTMLElement | null;
};
export type FormContextValue = {
  busy: boolean;
  dirty: boolean;
  errors: ApiErrors;
  register: (name: string, field: RegisteredControl) => () => void;
  /** Custom controls report value changes that do not emit native change events. */
  markChanged: () => void;
  /** Overlays route Cancel, Escape and backdrop dismissal through this guard. */
  requestDiscard: (discard: () => void) => void;
};
export const FormContext = createContext<FormContextValue | null>(null);
export const useFormState = () => useContext(FormContext);
